import { useEffect, useRef, useState } from 'react';

const THRESHOLD = 80; // px to trigger reload

export function PullToRefresh() {
  const startYRef = useRef<number | null>(null);
  const [pullDistance, setPullDistance] = useState(0);
  const [triggered, setTriggered] = useState(false);
  const activeRef = useRef(false);

  useEffect(() => {
    function onTouchStart(e: TouchEvent) {
      if (window.scrollY === 0) {
        startYRef.current = e.touches[0].clientY;
        activeRef.current = true;
      }
    }

    function onTouchMove(e: TouchEvent) {
      if (!activeRef.current || startYRef.current === null) return;
      const delta = e.touches[0].clientY - startYRef.current;
      if (delta <= 0) {
        setPullDistance(0);
        return;
      }
      // Dampen the pull so it feels springy
      const damped = Math.min(delta * 0.5, THRESHOLD * 1.2);
      setPullDistance(damped);
      if (damped >= THRESHOLD) setTriggered(true);
      else setTriggered(false);
    }

    function onTouchEnd() {
      if (!activeRef.current) return;
      activeRef.current = false;
      startYRef.current = null;
      if (triggered) {
        window.location.reload();
      } else {
        // Animate back
        setPullDistance(0);
        setTriggered(false);
      }
    }

    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchmove', onTouchMove, { passive: true });
    document.addEventListener('touchend', onTouchEnd);

    return () => {
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
    };
  }, [triggered]);

  if (pullDistance <= 0) return null;

  const progress = Math.min(pullDistance / THRESHOLD, 1);
  const rotation = progress * 360;

  return (
    <div
      className="fixed top-0 left-0 right-0 flex justify-center pointer-events-none z-50"
      style={{ transform: `translateY(${pullDistance - 24}px)` }}
    >
      <div
        className={`w-10 h-10 rounded-full shadow-md flex items-center justify-center transition-colors duration-150 ${
          triggered ? 'bg-green-600' : 'bg-white'
        }`}
        style={{ opacity: progress }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`w-5 h-5 ${triggered ? 'text-white' : 'text-green-700'}`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ transform: `rotate(${rotation}deg)` }}
        >
          <polyline points="23 4 23 10 17 10" />
          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
        </svg>
      </div>
    </div>
  );
}
